const styles = {
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#fff',
    boxShadow:
      '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)',
    padding: '16px 32px 24px',
    borderRadius: '15px',
  },
  form: {
    width: '100%',
    marginTop: '8px',
  },
  title: {},
  submit: {
    margin: '24px 0px 16px',
  },
  logo: {
    height: '40px',
    marginBottom: '16px',
  },
  illustration: {
    width: '100%',
    marginBottom: '16px',
  },
  errorBox: {
    marginTop: '8px',
    marginBottom: '16px',
    padding: '16px',
    backgroundColor: 'rgb(255, 145, 144)', // This color depends on your theme.
  },
  error: {
    color: 'white', // You can adjust this color as needed.
  },
}
export default styles
